// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"marqueeGroup__wrapper__24C5Y"};